// extracted by mini-css-extract-plugin
export default {"submitGroup":"ProfilePageForm_submitGroup__s5Owz"};